import { render, staticRenderFns } from "./index.vue?vue&type=template&id=53786dc4&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=53786dc4&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53786dc4')) {
      api.createRecord('53786dc4', component.options)
    } else {
      api.reload('53786dc4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=53786dc4&lang=pug", function () {
      api.rerender('53786dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/account/index.vue"
export default component.exports